export default __webpack_public_path__ + "static/media/INFINITYPAD.7b3058ad.png";